<ng-container *ngIf="benefitsPanel">
  <dgx-components-panel
    [border]="false"
    [dgxTestHook]="testHooks.RegistrationBenefitsPanel"
    [rounded]="rounded"
    [variant]="variant"
    class="appliance-details-stepped-benefits-panel__panel"
  >
    <h2 class="appliance-details-stepped-benefits-panel__title mb-3">
      {{ benefitsPanel.title }}
    </h2>

    <div class="appliance-details-stepped-benefits-panel__content">
      <dgx-cms-icon-list
        [circle]="true"
        [emphasis]="true"
        [items]="benefitsPanel.benefits"
        [noWrap]="true"
        [spacing]="3"
        [theme]="variant"
        class="appliance-details-stepped-benefits-panel__content-icon-list"
      />
    </div>
  </dgx-components-panel>
</ng-container>
